export const DATE_FORMATS = {
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const YEAR_PICKER_MAT_DATE_FORMAT = {
  // Year only format
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateA11yLabel: 'LL',
    dateInput: 'YYYY',
    monthYearA11yLabel: 'YYYY',
    monthYearLabel: 'YYYY',
  },
};
